<div class="idp__slimbanner idp__slimbanner--wrapper">
  <div
    class="banner-row banner-row-container idp__slimbanner--container"
    [ngClass]="bannerRowClass"
    [ngStyle]="styles?.banner!"
  >
    <ng-container *ngIf="desktopBannerEnabled">
      <div
        class="idp__slimbanner--imageplaceholder idp__slimbanner--desktop banner-d-sm-none banner-d-md-block banner-col-1 text-align-center"
      >
        <idp-image
          class="idp__slimbanner--image-desktop"
          [content]="content.imageContent?.desktop!"
        ></idp-image>
      </div>
    </ng-container>

    <ng-container *ngIf="mobileBannerEnabled">
      <div
        class="idp__slimbanner--imageplaceholder idp__banner--mobile banner-d-none banner-d-sm-block banner-d-md-none banner-col-1"
      >
        <idp-image
          class="idp__slimbanner--image-mobile"
          [content]="content.imageContent?.mobile!"
        ></idp-image>
      </div>
    </ng-container>

    <div class="idp__slimbanner--content banner-col-11">
      <div class="banner-row margin-0">
        <div class="banner-col-12 padding-0 margin-auto">
          <idp-heading
            *ngIf="!!content.headerText"
            [styles]="headerStyles"
            [content]="headerContent"
            class="idp__slimbanner--heading"
          ></idp-heading>
        </div>
        <ng-container *ngIf="!!content.description && !!styles.description">
          <div class="banner-col-12 padding-0 idp__slimbanner--description">
            <idp-text
              class="idp__slimbanner--subheading"
              [styles]="styles.description"
              [content]="content.description"
            ></idp-text>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
